import { GetValueByFieldAndDirection, SortByValue } from '../../types';

const getValueByFieldAndDirection = ({
  values,
  defaultDirection,
  defaultField
}: GetValueByFieldAndDirection): SortByValue | undefined =>
  values.find(
    ({ field, direction }) =>
      direction === defaultDirection && field === defaultField
  );

export default getValueByFieldAndDirection;
